// extracted by mini-css-extract-plugin
module.exports = {"mailIconColor":"var(--gray-3)","leftArrowColor":"var(--gray-3)","checkMarkColor":"var(--green-4)"};